<template>
  <div style="height: 100%" class="column no-wrap">
    <user-info-card
      v-if="userDetail"
      :userDetail="userDetail"
      class="q-mb-none col-3"
      style="z-index: 9"
    />
    <q-tab-panels
      v-model="tab"
      animated
      class="q-pa-none col-8"
      style="margin-top: -40px"
    >
      <!-- 样本详情页面 -->
      <q-tab-panel name="sampleDetailInfo" class="q-ma-none q-pa-none">
        <div
          v-if="sample.detail"
          class="q-mx-lg q-mb-none bg-grey-3"
          id="_member_sample_detail"
        >
          <q-btn flat rounded color="gray" :to="{ name: 'member-index' }">
            <q-icon
              style="font-size: 13px"
              name="fas fa-arrow-left"
              class="q-mr-sm"
            />
            <span style="font-size: 13px">返回</span>
          </q-btn>
          <!-- 详情文字信息 -->
          <p class="q-my-sm text-subtitle1 text-bold">样本详情</p>
          <div style="font-size: 13px">
            <strong class="text-grey-9 q-mb-sm">样本名称：</strong
            >{{ sample.detail.name }} <br />
            <strong class="text-grey-9 q-mb-sm">样本ID：</strong>
            {{ sample.detail.sample_id }} <br />
            <strong class="text-grey-9 q-mb-sm">注册地址：</strong>
            {{ sample.detail.dom ? sample.detail.dom : "缺失" }} <br />
            <strong class="text-grey-9 q-mb-sm">经营地址</strong>:
            {{ sample.detail.addr ? sample.detail.addr : "缺失" }}<br />
            <strong class="text-grey-9 q-mb-sm">联系方式：</strong
            >{{ sample.detail.tel ? sample.detail.tel : "缺失" }} <br />
            <br />
            <div v-if="sample.telp_intv && sample.telp_intv.telp_intv_note">
              <strong class="text-red-9 q-mb-sm">电访员备注：</strong
              >{{
                sample.telp_intv.telp_intv_note
                  ? sample.telp_intv.telp_intv_note
                  : "缺失"
              }}
            </div>
          </div>
          <!-- lable -->
          <div class="q-my-sm row items-center">
            <q-chip
              v-for="label in sample.labels"
              :key="label.id"
              size="sm"
              color="primary"
              class="text-white"
            >
              {{ label.description }}
            </q-chip>
            <show-image-button
              v-if="sample"
              :hasImage="hasImage"
              :sample="sample"
            />
          </div>
          <!-- 备注信息 -->
          <div>
            <strong style="font-size: 12px" class="text-grey-9 q-mb-sm"
              >备注信息：</strong
            >{{
              sample.detail.member_note
                ? sample.detail.member_note
                : "暂无备注信息"
            }}
          </div>
        </div>
        <div
          class="row items-center q-mx-lg q-pa-md q-mt-none bg-grey-4"
          style="border-radius: 0px 0px 7px 7px"
        >
          <div class="q-mr-lg">
            <q-icon
              name="fas fa-exclamation-triangle"
              class="text-grey-7 q-mr-sm"
            />
            <span class="text-grey-7">注意</span>
          </div>
          <div style="font-size: 12px">
            <ul>
              1.给出的地址供参考，建议通过联系方式与样本取得联系。
            </ul>
            <ul>
              2.接触样本后请及时更新样本标签。
            </ul>
            <ul>
              3.如联系上样本，及时记录样本备注信息，方便后续交流。
            </ul>
          </div>
        </div>
      </q-tab-panel>

      <!-- 地图 -->
      <q-tab-panel
        name="sampleMapPanel"
        class="q-ma-none q-pa-none q-pb-lg full-height col-grow no-scroll"
      >
        <sample-detail-map :sample="sample" />
      </q-tab-panel>
      <!-- 样本的 -->
      <q-tab-panel name="sampleNoteEdit">
        <sample-datail-info-edit
          :editableLabel="editableLabel"
          :sample="sample"
        />
      </q-tab-panel>
    </q-tab-panels>

    <div
      class="q-mx-md q-pa-sm row justify-between fixed-bottom bg-white"
      style="max-width: 800px; margin: auto"
    >
      <div style="width: 275px" class="justify-between row no-wrap">
        <q-btn
          flat
          class="q-mr-lg bg-blue-9 text-white"
          @click="taggleSampleEditPanel()"
          :disable="mapPanelOpen"
          style="width: 110px"
        >
          <q-icon
            size="13px"
            :name="editPanelOpen ? 'fas fa-arrow-left' : 'fas fa-edit'"
            class="q-mr-sm"
          />
          <span> {{ editPanelOpen ? "返回" : "添加信息" }}</span>
        </q-btn>
        <q-btn
          flat
          class="q-ml-lg bg-blue-9 text-white"
          @click="taggleSampleMapPanel()"
          :disable="editPanelOpen"
          style="width: 110px"
        >
          <q-icon
            size="13px"
            :name="mapPanelOpen ? 'fas fa-arrow-left' : 'fas fa-map'"
            class="q-mr-sm"
          />
          <span> {{ mapPanelOpen ? "返回" : "查看地图" }} </span>
        </q-btn>
      </div>
      <q-btn
        outline
        class="text-primary rounded-borders"
        :to="{ name: 'member-index' }"
      >
        <q-icon size="13px" name="fas fa-arrow-left" class="q-mr-sm" />
        <span>上一步</span>
      </q-btn>
      <q-btn
        flat
        class="bg-primary text-white rounded-borders"
        :to="{ name: 'member-sample-check' }"
      >
        <span>下一步</span>
        <q-icon size="13px" name="fas fa-arrow-right" class="q-ml-sm" />
      </q-btn>
    </div>
  </div>
</template>
<script>
import UserDetailMixin from "../user-detail.mixin";

import SampleLabelMixin from "../sample-label.mixin";
export default {
  mixins: [UserDetailMixin, SampleLabelMixin],
  components: {
    UserInfoCard: () => import("../components/UserInfoCard.vue"),
    SampleInfoCard: () => import("../components/SampleInfoCard.vue"),
    ShowImageButton: () => import("../components/ShowImageButton.vue"),
    SampleDetailMap: () => import("./SampleDetailMap.vue"),
    Loading: () => import("@/components/Loading"),
    SampleDatailInfoEdit: () => import("./SampleDetailInfoEdit.vue"),
  },
  data() {
    return {
      tab: "sampleDetailInfo",
      note: "",
      sample: {},
      files: null,
      uploadProgress: [],
      editableLabel: [],
      uploading: null,
      isUploaded: false,
      showImageDialog: false,
    };
  },
  watch: {
    userDetail: {
      immediate: true,
      handler(current) {
        if (!current) return;
        this.sample = this.userDetail.samples.find((sample) => {
          return sample.id === this.$route.params.sample_id;
        });
        this.note = this.sample.detail.member_note;
      },
    },

    sampleLabel: {
      immediate: true,
      handler(current) {
        if (!current) return;
        this.editableLabel = this.sampleLabel.filter((label) => {
          return label.user_can_edit;
        });
      },
    },
  },

  computed: {
    hasImage() {
      return this.sample.detail.member_attachment_urls !== null;
    },

    editPanelOpen() {
      return this.tab === "sampleNoteEdit";
    },
    mapPanelOpen() {
      return this.tab === "sampleMapPanel";
    },

    isUploading() {
      return this.uploading !== null;
    },
    canUpload() {
      return this.files !== null;
    },
    currentSample() {
      return [this.sample];
    },
  },

  methods: {
    taggleSampleEditPanel() {
      if (this.tab === "sampleNoteEdit") {
        this.tab = "sampleDetailInfo";
      } else if (this.tab === "sampleDetailInfo") {
        this.tab = "sampleNoteEdit";
      }
    },

    taggleSampleMapPanel() {
      if (this.tab === "sampleMapPanel") {
        this.tab = "sampleDetailInfo";
      } else if (this.tab === "sampleDetailInfo") {
        this.tab = "sampleMapPanel";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#_member_sample_detail {
  padding: 3% 6%;
}
</style>